import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ActivityIndicator, TouchableOpacity, Dimensions, View, StyleSheet } from 'react-native';
import Modal from 'react-native-modal';

import Colors from '../../constants/Colors';
import FilledButton from '../FilledButton';

import { AppText } from '../AppText';

const styles = StyleSheet.create({
  view: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  confirmText: {
    fontSize: 20,
    margin: 16,
  },
  contentContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: Colors.white,
    width: 320,
  },
  buttonRow: {
    height: 52,
    backgroundColor: Colors.lightGrayBackground,
    borderTopWidth: 1,
    borderTopColor: Colors.grayBorder,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingTop: 8,
    paddingRight: 8,
  },
  disabledButton: {
    padding: 10,
    backgroundColor: Colors.grayButton,
  },
  confirmButton: {
    padding: 10,
    marginBottom: 6,
    backgroundColor: Colors.primaryColor,
    borderRadius: 4,
  },
  cancelText: {
    marginTop: 10,
    marginRight: 20,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  buttonText: {
    color: Colors.white,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
});

function Logout(props) {
  const { translation, logout } = props;

  const [showModal, setShowModal] = useState(false);

  const confirmLogout = () => {
    setShowModal(false);
    setTimeout(() => {
      logout();
    }, 300);
  };

  const labels = {
    confirmText: translation.app_dialog_clarify_prompt,
    cancel: translation.app_button_cancel,
    ok: translation.app_button_ok,
    logout: translation.app_button_logout,
  };

  const deviceWidth = Dimensions.get('window').width;
  const deviceHeight = Dimensions.get('window').height;

  const modal = (
    <Modal isVisible={showModal} deviceHeight={deviceHeight} deviceWidth={deviceWidth} statusBarTranslucent>
      <View style={styles.contentContainer}>
        <AppText style={styles.confirmText}>{labels.confirmText}</AppText>
        <View style={styles.buttonRow}>
          <TouchableOpacity onPress={() => setShowModal(false)}>
            <AppText style={styles.cancelText}>{labels.cancel}</AppText>
          </TouchableOpacity>
          <TouchableOpacity onPress={confirmLogout} style={styles.confirmButton} testID="confirm-logout">
            <AppText style={styles.buttonText}>{labels.ok}</AppText>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );

  return (
    <View style={styles.view}>
      <FilledButton
        onPress={() => setShowModal(true)}
        label={labels.logout}
        full={false}
        color={Colors.primaryColor}
        textColor={Colors.primaryColor}
        backgroundColor={Colors.white}
        disabled={false}
        height={40}
        radius={4}
      />

      {modal}
    </View>
  );
}

Logout.propTypes = {
  translation: PropTypes.objectOf(PropTypes.any).isRequired,
  logout: PropTypes.func.isRequired,
};

export default Logout;
